// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3c2LK","actionsCol":"EnrolledClinics_actionsCol__1FJ-H"};